import '@/polyfills';

import { createApp } from 'vue';
import { createPinia, setActivePinia } from 'pinia';
import App from '@/App.vue';
import router from '@/router';
import authService from '@/services/auth';
import analyticsService from '@/services/analytics';
import initializeHttpInterceptors from '@/http/interceptors';
import { useUserStore } from '@/stores/user';

import '@/assets/scss/base.scss';
import vuetify from '@/plugins/vuetify';
import { vueI18n } from '@/plugins/i18n';
import sentry from '@/plugins/sentry';
import { installCasl } from '@/plugins/casl';
import { env } from '@/utils/env';

import '@/plugins/vee-validate';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';

const app = createApp(App);
const pinia = createPinia();
setActivePinia(pinia);

app.use(pinia);
app.use(router);
app.use(vueI18n);
app.use(vuetify);
installCasl(app);

const sentryDsn = env('SENTRY_DSN');
if (process.env.NODE_ENV === 'production' && sentryDsn) {
  app.use(sentry, {
    dsn: sentryDsn,
  });
}

analyticsService.init();
authService.restoreAuthTokens();
initializeHttpInterceptors();
useUserStore().initUserRole();

app.mount('#app');
